import { createFileRoute } from '@tanstack/react-router'
import { Landmark } from 'lucide-react'
import { z } from 'zod'
import { DetailsScreen } from '@/screens/billing/SCR-165-details'

export const Route = createFileRoute('/_app/billing/details')({
  staticData: { screen: { id: 'SCR-165', title: 'Billing details', group: 'Organisation', perm: 'billing.manage', hidden: true, description: 'Legal name, address and GSTIN printed on your invoices.', icon: Landmark } },
  validateSearch: z.object({
    return_to: z.enum(['checkout']).optional(),
    plan: z.enum(['team', 'business']).optional(),
    interval: z.enum(['month', 'year']).optional(),
    seats: z.coerce.number().int().min(1).max(1000).optional(),
  }),
  component: function DetailsRoute() {
    const { return_to, plan, interval, seats } = Route.useSearch()
    return <DetailsScreen returnTo={return_to} back={{ ...(plan ? { plan } : {}), ...(interval ? { interval } : {}), ...(seats ? { seats } : {}) }} />
  },
})
